import styled from "styled-components";
import { theme } from "../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";

export const Col = styled.div`
    padding: 0 ${theme.spacer / 2}px;
`;

export const Row = styled.div<{ isClickable?: boolean }>`
    flex: 1 1 auto;
    flex-wrap: wrap;
    margin: 0 -${theme.spacer / 2}px;
    padding: 8px 0;
    font-size: 12px;
    line-height: 1.6;
    background: ${theme.colors.white};
    cursor: ${(props) => (props.isClickable ? "pointer" : "default")};
    overflow-wrap: break-word;

    &:nth-child(even) {
        background: ${theme.colors.silver};
    }

    strong {
        margin-inline-end: 8px;
        font-size: 13px;
    }

    select {
        border-radius: 3px;
        border-width: 1px;
    }

    span + select {
        margin-inline-start: 6px;
    }

    input[type="checkbox"] {
        margin-inline-end: 6px;
        vertical-align: middle;
    }
`;
